import { Observable } from "rxjs";
import { DynamicAction } from "./dynamic-action.model";
import { DynamicColumn } from "./dynamic-column.model";
import { DynamicDraggingColumn } from "./dynamic-dragging-column.model";
import { DynamicField } from "./dynamic-field.model";
import CustomStore from "devextreme/data/custom_store";

export class DynamicGrid<U, T> extends DynamicField<T> {

    source?: Array<U> | CustomStore;
    sourceObserver?: Observable<Array<U>>;
    columns?: Array<DynamicColumn<U>>;
    allowExporting?: boolean;
    group?: boolean;
    actions?: Array<DynamicAction>;
    draggingColumn?: DynamicDraggingColumn<T>;
    selection?: boolean;
    showPagination?: boolean;
    showSearchPanel?: boolean;
    hiddenOn?: 'sourcelength' | boolean | '';

    constructor(source: Partial<DynamicGrid<U, T>>) {
        super();
        this.showPagination = true;
        this.showSearchPanel = true;
        Object.assign(this, source);

        this.sourceObserver?.subscribe(data => {
            this.source = data;
        });
    }

}